<script lang="ts">
	const { gaId }: { gaId?: string } = $props();
</script>

<svelte:head>
	{#if gaId}
		<script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}></script>
		{@html `
		<script>
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}
			gtag('js', new Date());
			gtag('config', '${gaId}')
		</script>
		`}
	{/if}
</svelte:head>
